import React, { createContext, useState, useEffect } from "react";
import {getRemainingTimeBeforeRefresh, restoreSession} from "./OAuth-password-grant";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    const logout = () => {
        sessionStorage.clear();
        setIsAuthenticated(false);
    };

    const checkAuthentication = () => {
        const session = sessionStorage.getItem("session");
        return session !== null;
    };

    useEffect(() => {
        const init = async () => {
            const sessionValid = checkAuthentication();

            if (!sessionValid) {
                const success = await restoreSession();
                setIsAuthenticated(success);
            } else {
                setIsAuthenticated(true);
            }

            setLoading(false);
        };

        init();
    }, []);

    // useEffect(() => {
    //     const remaining = getRemainingTimeBeforeRefresh();
    //     if (remaining !== null) {
    //         console.log(`Le rafraîchissement du token aura lieu dans ${Math.floor(remaining / 1000)} secondes`);
    //     } else {
    //         console.log("Pas de session ou expiration inconnue.");
    //     }
    // }, []);


    return (
        <AuthContext.Provider value={{ logout, isAuthenticated, setIsAuthenticated }}>
            {children}
        </AuthContext.Provider>
    );
};
